import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

interface TechnologiesBragProps {
  backgroundGradient?: boolean;
}

export const ContainerStyled = styled("div")<TechnologiesBragProps>(
  ({ theme, backgroundGradient = true }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0 2rem 0;
    margin-left: auto;
    margin-right: auto;
    gap: 1rem;
    ${backgroundGradient &&
    css`
      background: radial-gradient(
        50% 44.06% at 50% 100%,
        rgba(45, 238, 125, 0.12) 0%,
        rgba(118, 210, 204, 0) 100%
      );
      border-bottom: 1px solid ${getColor(c => c.tokens.bg["soft-200"], theme)};
    `}

    p:first-of-type {
      ${cssForHeaderWithLinearGradient(theme)}
      text-align: center;

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_mobile)}
        margin: 0.5rem auto 0 auto;
        padding: 0 1rem;
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
        margin: 0.5rem auto 0 auto;
        max-width: 600px;
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
        max-width: 700px;
        margin: 1rem auto 0 auto;
      }
    }

    p:not(:first-of-type) {
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};
      text-align: center;

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
        padding: 0 1rem;
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.paragraph_large_medium)}
        max-width: 600px;
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
        max-width: 850px;
      }
    }
  `,
);
